import React from 'react';
import {
    Card,
    SimpleTableHeader,
    SimpleTableRow,
    SimpleTable,
    WarningModal,
} from 'components';
import { Color } from '_helpers';
import { IApiError } from '_helpers/ApiConnector/types';
import emptyCertificateIcon from 'components/assets/svg/qec/empty_certificate_icon.svg';
import moment from 'moment';

const ApplicantQualifications = ({
    getQualificationsList,
    qualificationList,
    title,
    category,
    getQualificationDetails,
    apiError,
}: IProps) => {
    React.useEffect(() => {
        getQualificationsList();
    }, []);

    const [showErrorModal, setShowErrorModal] = React.useState(false);

    const checkCertificateStatus = (issueDate: moment.Moment, expireDate: moment.Moment): boolean => moment().isBetween(issueDate, expireDate);

    const onQualificationListRowClick = async (examApplicationId: string | number) => {
        if (getQualificationDetails) {
            const res = await getQualificationDetails(`${examApplicationId}`);

            if (!res) {
                setShowErrorModal(true);
            }
        }
    };

    const tableHeaders: SimpleTableHeader[] = [
        { title: 'КВАЛИФИКАЦИЯ', columnStyles: { width: '100%', textAlign: 'start' } },
        { title: 'СРОК ДЕЙСТВИЯ', columnStyles: { minWidth: '13rem', textAlign: 'start' } },
        { title: 'СТАТУС', columnStyles: { minWidth: '8rem', textAlign: 'right' } },
    ];

    const tableRows: SimpleTableRow[] = !qualificationList ? [] : qualificationList.map((item) => {
        const isActualCertificate = item.issueDate && item.expireDate ? checkCertificateStatus(item.issueDate, item.expireDate) : false;
        return {
            id: item.examApplicationId,
            columns: [
                <span>{item.title}</span>,
                `${item.issueDate.format('DD.MM.YYYY')}-${item.expireDate.format('DD.MM.YYYY')}`,
                <span style={{ color: `var(${isActualCertificate ? Color.Success : Color.Red})` }}>
                    {isActualCertificate ? 'Действует' : 'Не действует'}
                </span>,
            ],
        };
    });

    return (
        <Card
          title={title || 'Квалификации'}
          category={category || 'Список квалификаций, присвоенных соискателю'}
          withoutBorder
          withoutPadding
        >
            <SimpleTable
              tableHeaders={tableHeaders}
              tableRows={tableRows}
              handleRowClick={onQualificationListRowClick}
              placeholderIcon={emptyCertificateIcon}
              placeholderTitle="Нет присвоенных квалификаций"
              placeholderText="Здесь будут квалификации, присвоенные соискателю"
            />
            {apiError && showErrorModal ? (
                <WarningModal
                  title={apiError.message}
                  onHide={() => setShowErrorModal(false)}
                  show={showErrorModal}
                />
            ) : null}
        </Card>
    );
};

export default ApplicantQualifications;

interface IProps {
    qualificationList: IQualification[] | null;
    apiError: IApiError | null;
    title?: string;
    category?: string;
    getQualificationsList: () => void;
    getQualificationDetails?: (examApplicationId: string) => Promise<IQualification | null | boolean>;
}

interface IQualification {
    examApplicationId: string;
    regNumber: string;
    title: string;
    level: string;
    issueDate: moment.Moment;
    expireDate: moment.Moment;
}
